"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLive = void 0;
var tslib_1 = require("tslib");
var uuid_1 = require("./shared-utils/uuid");
var equal_1 = require("./shared-utils/equal");
var appendUri_1 = require("./shared-utils/appendUri");
var Subscribe_1 = require("./shared-utils/Subscribe");
var WebSocket_1 = require("./typings/WebSocket");
var LiveMsg_1 = require("./typings/LiveMsg");
var RTC_1 = require("./RTC");
var LiveController = /** @class */ (function () {
    function LiveController(options) {
        var _this = this;
        this.readyState = WebSocket_1.WebSocketState.NOTINITIALIZED;
        this.canSync = true;
        this.connecting = false;
        this.keyframes = {};
        /**
         * 检测 WebSocket.readyState 状态
         */
        this.checkReadyState = function (live) {
            do {
                if (!_this.webSocket) {
                    if (_this.readyState !== WebSocket_1.WebSocketState.NOTINITIALIZED) {
                        _this.readyState = WebSocket_1.WebSocketState.NOTINITIALIZED;
                        live.emit('ws.readyStateUpdate', _this.readyState);
                    }
                    break;
                }
                var readyState = _this.webSocket.readyState;
                if (readyState !== _this.readyState) {
                    _this.readyState = readyState;
                    live.emit('ws.readyStateUpdate', _this.readyState);
                }
            } while (false);
            return _this.readyState;
        };
        this.dispose = function () {
            console.log('dispose');
            _this.disposeWebSocket();
            _this.connecting = false;
            if (_this.healthCheckId) {
                clearInterval(_this.healthCheckId);
                _this.healthCheckId = undefined;
            }
        };
        /**
         * 销毁WebSocket相关依赖。
         */
        this.disposeWebSocket = function () {
            if (!_this.webSocket)
                return;
            if (_this.onEvtOpnListener) {
                _this.webSocket.removeEventListener('open', _this.onEvtOpnListener);
                _this.onEvtOpnListener = undefined;
            }
            if (_this.onEvtMsgListener) {
                _this.webSocket.removeEventListener('message', _this.onEvtMsgListener);
                _this.onEvtMsgListener = undefined;
            }
            if (_this.onEvtErrListener) {
                _this.webSocket.removeEventListener('error', _this.onEvtErrListener);
                _this.onEvtErrListener = undefined;
            }
            if (_this.onEvtCLEListener) {
                _this.webSocket.removeEventListener('close', _this.onEvtCLEListener);
                _this.onEvtCLEListener = undefined;
            }
            _this.webSocket.close();
            _this.webSocket = undefined;
        };
        this.options = Object.assign({ autoConnect: true, healthCheck: 3000 }, options);
    }
    /**
     * 解析数据
     * @param msgInfo
     * @param live
     */
    LiveController.prototype.handleMessage = function (liveMsg, live) {
        var _this = this;
        var _a, _b, _c;
        var command = liveMsg.command, data = liveMsg.data, frontRequestId = liveMsg.frontRequestId, code = liveMsg.code, message = liveMsg.message;
        if (code !== 'SUCCESS') {
            return live.emit('error', liveMsg);
        }
        switch (command) {
            case LiveMsg_1.Command.SelfUserInfo: {
                var selfInfo = data;
                if ((0, equal_1.equal)(this.selfUserInfo, selfInfo, { deep: true }))
                    return;
                this.selfUserInfo = selfInfo;
                live.emit('selfInfoUpdate', this.selfUserInfo, frontRequestId);
                break;
            }
            case LiveMsg_1.Command.RoomInfo: {
                var roomInfo = data;
                this.roomInfo = Object.assign({}, roomInfo);
                live.emit('readyKeyframeSync', (roomInfo.last_frame || {}));
                break;
            }
            case LiveMsg_1.Command.RTCInfo: {
                var _d = data, voiceId = _d.voice_id, type = _d.type;
                /* 如果已经进入语音房间，则不重复进入 --> "RTCInfo" 指令可能会下发多次 */
                if (live.$RTC.joined) {
                    break;
                }
                live.$RTC.join({
                    voiceId: voiceId,
                    userId: ((_a = this.selfUserInfo) === null || _a === void 0 ? void 0 : _a.id) || "",
                    roomId: (_b = this.roomInfo) === null || _b === void 0 ? void 0 : _b.info.room_code,
                    type: type,
                });
                // 加入房间后 麦克风默认就开启了：需要发个指令。
                live.updateStatus(LiveMsg_1.BuiltinEventType.UserChange, LiveMsg_1.BuiltinActionType.UserMicroStatus, {
                    status: LiveMsg_1.MicroStatus.OPEN
                });
                break;
            }
            case LiveMsg_1.Command.UserList: {
                var userList = data;
                this.userList = userList;
                live.emit('userListUpdate', this.userList, frontRequestId);
                break;
            }
            case LiveMsg_1.Command.CustomEvent: {
                var evtMsg = data;
                live.emit('broadcast', evtMsg, frontRequestId);
                break;
            }
            case LiveMsg_1.Command.KeyframeSync: {
                var remoteKeyframes_1 = data;
                // 此处做一层 diff，仅跟本地数据不一致的情况下才广播数据。
                var keyframes = Object.keys(remoteKeyframes_1)
                    .reduce(function (accu, curr) {
                    var _a;
                    if ((0, equal_1.equal)(remoteKeyframes_1[curr], _this.keyframes[curr], { deep: true })) {
                        return accu;
                    }
                    var params = [remoteKeyframes_1[curr], _this.keyframes[curr], frontRequestId];
                    (_a = live.keyframes).emit.apply(_a, (0, tslib_1.__spreadArray)([curr], params, false));
                    _this.keyframes[curr] = remoteKeyframes_1[curr];
                    accu[curr] = remoteKeyframes_1[curr];
                    return accu;
                }, {});
                live.emit('keyframes', keyframes, frontRequestId);
                break;
            }
            case LiveMsg_1.Command.BuiltinMsg: {
                var builtinMsg = data;
                live.emit('builtinEvent', builtinMsg);
                if (builtinMsg.event_type === LiveMsg_1.BuiltinEventType.UserChange) {
                    live.emit('userChange', builtinMsg);
                }
                if (builtinMsg.event_type === LiveMsg_1.BuiltinEventType.RoomChange) {
                    live.emit('roomChange', builtinMsg);
                }
                /**
                 * 下发指令自己操作麦克风
                 */
                if (builtinMsg.event_type === LiveMsg_1.BuiltinEventType.UserChange && builtinMsg.action === LiveMsg_1.BuiltinActionType.UserMicroStatus) {
                    live.toggleMicro(builtinMsg.data.status === LiveMsg_1.MicroStatus.OPEN);
                }
                /**
                 * 如果下发指令退出房间，则 关闭麦克风 及 销毁 WebSocket
                 */
                if (builtinMsg.event_type === LiveMsg_1.BuiltinEventType.RoomChange && builtinMsg.action === LiveMsg_1.BuiltinActionType.RoomClose) {
                    (_c = this.options.rtc) === null || _c === void 0 ? void 0 : _c.quit();
                    this.disposeWebSocket();
                }
                break;
            }
            case LiveMsg_1.Command.UserKickOut: {
                live.emit('kickOut');
            }
        }
    };
    /**
     * 发送数据
     * @param data
     */
    LiveController.prototype.sendMessage = function (data) {
        if (!this.webSocket)
            return console.warn('WebSocket has not yet been initialized!');
        if (!data)
            return console.warn('WebSocket messages is empty!');
        this.webSocket.send(JSON.stringify(data));
    };
    return LiveController;
}());
/**
 * 创建 `live` 实例。
 */
function createLive(options) {
    var liveController = new LiveController(options);
    var createLiveMsg = function (command, data, toUserIds) {
        if (data === void 0) { data = {}; }
        toUserIds = toUserIds ? (Array.isArray(toUserIds) ? toUserIds : [toUserIds]) : [];
        if (toUserIds)
            data['to_user_ids'] = toUserIds;
        return { command: command, front_request_id: (0, uuid_1.uuid)(), data: data };
    };
    var LiveTpl = /** @class */ (function (_super) {
        (0, tslib_1.__extends)(LiveTpl, _super);
        function LiveTpl() {
            var _this = _super.call(this) || this;
            _this.keyframes = new Subscribe_1.Subscribe();
            if (!options.rtc) {
                liveController.options.rtc = new RTC_1.RTCExample();
            }
            // 默认自动连接
            if (liveController.options.url && liveController.options.getTicket) {
                _this.connect();
            }
            // 健康检查：WHY --> 在某些WebView特殊场景下 WebSocket.readyState 发生变化时不会出发error\close等事件;
            //         因此，开启一个定时任务监测 WebSocket.readyState 状态的更新
            var healthCheck = (function (healthCheck) {
                if (!healthCheck)
                    return 0;
                if (healthCheck === true)
                    return 3000;
                var duration = Number(healthCheck);
                if (duration > 0)
                    return duration;
                return 3000;
            })(liveController.options.healthCheck);
            if (healthCheck) {
                liveController.healthCheckId = setInterval(function () { return liveController.checkReadyState(_this); }, healthCheck);
            }
            return _this;
        }
        Object.defineProperty(LiveTpl.prototype, "options", {
            get: function () {
                return Object.freeze(Object.assign({}, liveController.options));
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LiveTpl.prototype, "readyState", {
            get: function () {
                liveController.checkReadyState(this);
                return liveController.readyState;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LiveTpl.prototype, "url", {
            get: function () {
                var _a;
                return ((_a = liveController.webSocket) === null || _a === void 0 ? void 0 : _a.url) || '';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LiveTpl.prototype, "selfInfo", {
            get: function () {
                return liveController.selfUserInfo;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LiveTpl.prototype, "userList", {
            get: function () {
                return liveController.userList || [];
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LiveTpl.prototype, "snapshot", {
            get: function () {
                return liveController.keyframes || {};
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LiveTpl.prototype, "$RTC", {
            get: function () {
                return liveController.options.rtc;
            },
            enumerable: false,
            configurable: true
        });
        LiveTpl.prototype.setSelfInfo = function (userInfo) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var error_1;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.readyState !== WebSocket_1.WebSocketState.OPEN) {
                                return [2 /*return*/, new Error('The connection is not open and ready to communicate.')];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.updateStatus(LiveMsg_1.BuiltinEventType.UserChange, LiveMsg_1.BuiltinActionType.UserInfo, userInfo)];
                        case 2: return [2 /*return*/, _a.sent()];
                        case 3:
                            error_1 = _a.sent();
                            return [2 /*return*/, error_1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        LiveTpl.prototype.getFramesByKey = function (key) {
            return liveController.keyframes[key];
        };
        LiveTpl.prototype.sendKeyframe = function (key, frame) {
            if (this.readyState !== WebSocket_1.WebSocketState.OPEN) {
                return new Error('The connection is not open and ready to communicate.');
            }
            liveController.keyframes[key] = frame;
            var liveMsg = createLiveMsg(LiveMsg_1.Command.KeyframeSync, this.snapshot);
            liveController.sendMessage(liveMsg);
            return true;
        };
        LiveTpl.prototype.broadcast = function (data, toUserIds, timeout) {
            var _this = this;
            if (this.readyState !== WebSocket_1.WebSocketState.OPEN) {
                return new Error('The connection is not open and ready to communicate.');
            }
            return new Promise(function (resolve, reject) {
                var customEvent = createLiveMsg(LiveMsg_1.Command.CustomEvent, data, toUserIds);
                var front_request_id = customEvent.front_request_id;
                liveController.sendMessage(customEvent);
                var timeoutId = timeout ? setTimeout(function () {
                    reject(new Error('RESPONSE TIMEOUT'));
                    _this.off('broadcast', broadcast);
                }, timeout) : undefined;
                var broadcast = function (data, frontRequestId) {
                    if (frontRequestId !== front_request_id)
                        return;
                    _this.off('broadcast', broadcast);
                    resolve(data);
                    if (timeoutId)
                        clearInterval(timeoutId);
                };
                _this.on('broadcast', broadcast);
            });
        };
        LiveTpl.prototype.updateStatus = function (evtType, atnType, status, toUserIds) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var data, liveMsg;
                return (0, tslib_1.__generator)(this, function (_a) {
                    if (this.readyState !== WebSocket_1.WebSocketState.OPEN) {
                        return [2 /*return*/, false];
                    }
                    data = Object.assign({ event_type: evtType, action: atnType }, { data: status });
                    liveMsg = createLiveMsg(LiveMsg_1.Command.BuiltinMsg, data, toUserIds);
                    liveController.sendMessage(liveMsg);
                    return [2 /*return*/, true];
                });
            });
        };
        // 仅用于用户自己的麦克风控制
        LiveTpl.prototype.toggleMicro = function (microStatus) {
            var _a, _b;
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!((_b = (_a = this.selfInfo) === null || _a === void 0 ? void 0 : _a.permission) === null || _b === void 0 ? void 0 : _b.control_own_micro))
                                return [2 /*return*/, false];
                            return [4 /*yield*/, this.$RTC.toggleMicro(microStatus)];
                        case 1:
                            _c.sent();
                            return [4 /*yield*/, this.updateStatus(LiveMsg_1.BuiltinEventType.UserChange, LiveMsg_1.BuiltinActionType.UserMicroStatus, {
                                    status: microStatus ? LiveMsg_1.MicroStatus.OPEN : LiveMsg_1.MicroStatus.CLOSE
                                }, [])];
                        case 2: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        LiveTpl.prototype.forbidMicro = function (microStatus, toUserIds) {
            var _a, _b;
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (liveController.options.canForbidUserMicro && !liveController.options.canForbidUserMicro(toUserIds)) {
                                return [2 /*return*/, false];
                            }
                            if (!((_b = (_a = this.selfInfo) === null || _a === void 0 ? void 0 : _a.permission) === null || _b === void 0 ? void 0 : _b.control_other_micro)) {
                                return [2 /*return*/, false];
                            }
                            return [4 /*yield*/, this.updateStatus(LiveMsg_1.BuiltinEventType.UserChange, LiveMsg_1.BuiltinActionType.UserMicroStatus, {
                                    status: microStatus
                                }, toUserIds)];
                        case 1: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        /**
         * @deprecated 暂不可用
         */
        LiveTpl.prototype.forbidSync = function (sync, toUserIds) {
            var _a, _b;
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (liveController.options.canForbidUserSync && !liveController.options.canForbidUserSync(toUserIds)) {
                                return [2 /*return*/, false];
                            }
                            if (!((_b = (_a = this.selfInfo) === null || _a === void 0 ? void 0 : _a.permission) === null || _b === void 0 ? void 0 : _b.control_other_sync)) {
                                return [2 /*return*/, false];
                            }
                            return [4 /*yield*/, this.updateStatus(LiveMsg_1.BuiltinEventType.UserChange, LiveMsg_1.BuiltinActionType.UserPermission, { sync_frame: sync }, toUserIds)];
                        case 1: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        LiveTpl.prototype.kick = function (toUserIds) {
            var _a, _b;
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (liveController.options.canForbidUserKick && !liveController.options.canForbidUserKick(toUserIds)) {
                                return [2 /*return*/, false];
                            }
                            if (!((_b = (_a = this.selfInfo) === null || _a === void 0 ? void 0 : _a.permission) === null || _b === void 0 ? void 0 : _b.change_other_status)) {
                                return [2 /*return*/, false];
                            }
                            return [4 /*yield*/, this.updateStatus(LiveMsg_1.BuiltinEventType.UserChange, LiveMsg_1.BuiltinActionType.UserStatus, {
                                    status: 'KICK_OUT'
                                }, toUserIds)];
                        case 1: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        LiveTpl.prototype.exit = function () {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: 
                        /** 退出强制关闭语音(?) */
                        return [4 /*yield*/, this.$RTC.quit()];
                        case 1:
                            /** 退出强制关闭语音(?) */
                            _a.sent();
                            return [4 /*yield*/, this.updateStatus(LiveMsg_1.BuiltinEventType.RoomChange, LiveMsg_1.BuiltinActionType.RoomClose, {})];
                        case 2: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        LiveTpl.prototype.connect = function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var microAuth, error, error, force, error, error, url, _a, _b, _c;
                var _d;
                var _this = this;
                return (0, tslib_1.__generator)(this, function (_e) {
                    switch (_e.label) {
                        case 0: return [4 /*yield*/, this.$RTC.detectMicro()];
                        case 1:
                            microAuth = _e.sent();
                            if (!microAuth) {
                                error = new Error('系统监测麦克风未授权~');
                                this.emit('ws.error', { type: WebSocket_1.WebSocketErrorType.MicroAuth, error: error });
                                return [2 /*return*/, error];
                            }
                            // WebSocket 正在连接中，规避重复连接
                            if (liveController.connecting) {
                                error = new Error('WebSocket 正在连接中，请勿重复连接 ...');
                                this.emit('ws.error', { type: WebSocket_1.WebSocketErrorType.DuplicateConnect, error: error });
                                return [2 /*return*/, error];
                            }
                            force = options.force;
                            if (!force) {
                                if (this.readyState === WebSocket_1.WebSocketState.CONNECTING || this.readyState === WebSocket_1.WebSocketState.OPEN) {
                                    return [2 /*return*/, true];
                                }
                            }
                            // WebSocket URL 逻辑
                            if (options.url) {
                                liveController.options.url = options.url;
                            }
                            if (options.getTicket) {
                                liveController.options.getTicket = options.getTicket;
                            }
                            if (!liveController.options.url || !liveController.options.url.startsWith('ws')) {
                                error = new Error("WebSocket URL \u672A\u914D\u7F6E\u6216\u683C\u5F0F\u4E0D\u5408\u6CD5\uFF1A\"" + liveController.options.url + "\"");
                                this.emit('ws.error', { type: WebSocket_1.WebSocketErrorType.IllegalURL, error: error });
                                return [2 /*return*/, error];
                            }
                            if (!liveController.options.getTicket) {
                                error = new Error("getTicket() \u672A\u914D\u7F6E!");
                                this.emit('ws.error', { type: WebSocket_1.WebSocketErrorType.IllegalArgs, error: error });
                                return [2 /*return*/, error];
                            }
                            // 连接锁
                            liveController.connecting = true;
                            // 连接前销毁之前绑定的事件
                            liveController.disposeWebSocket();
                            this.emit('ws.beforeConnect');
                            if (!(force || options.url || !this.url)) return [3 /*break*/, 3];
                            _b = appendUri_1.appendUri;
                            _c = [liveController.options.url];
                            _d = {};
                            return [4 /*yield*/, liveController.options.getTicket()];
                        case 2:
                            _a = _b.apply(void 0, _c.concat([(_d.ticket = _e.sent(),
                                    _d.force = Number(!!force),
                                    _d)]));
                            return [3 /*break*/, 4];
                        case 3:
                            _a = this.url;
                            _e.label = 4;
                        case 4:
                            url = _a;
                            liveController.webSocket = new WebSocket(url);
                            liveController.onEvtOpnListener = function () {
                                liveController.checkReadyState(_this);
                                _this.emit('ws.afterConnect');
                            };
                            liveController.onEvtMsgListener = function (evt) {
                                liveController.checkReadyState(_this);
                                try {
                                    var liveMsg = (0, LiveMsg_1.parseLiveMsg)(evt.data);
                                    if (liveMsg === false)
                                        return;
                                    liveController.handleMessage(liveMsg, _this);
                                }
                                catch (error) {
                                    // 未知错误
                                    _this.emit('ws.error', { type: WebSocket_1.WebSocketErrorType.Unknown, error: error, target: evt });
                                }
                            };
                            liveController.onEvtErrListener = function (evt) {
                                live.emit('ws.error', { type: WebSocket_1.WebSocketErrorType.Error, target: evt });
                                liveController.checkReadyState(_this);
                            };
                            liveController.onEvtCLEListener = function (evt) {
                                liveController.checkReadyState(_this);
                                var code = Number(evt.code);
                                if (code === 1000)
                                    return;
                                // 异常退出不一定会触发'error'事件，根据 evt.code 一些类型的退出也算是 error 行为
                                var errMsg = (0, WebSocket_1.parseWSClsErr)(code);
                                live.emit('ws.error', { target: evt, type: WebSocket_1.WebSocketErrorType.Close, closeError: errMsg });
                            };
                            liveController.webSocket.addEventListener('open', liveController.onEvtOpnListener);
                            liveController.webSocket.addEventListener('message', liveController.onEvtMsgListener);
                            liveController.webSocket.addEventListener('error', liveController.onEvtErrListener);
                            liveController.webSocket.addEventListener('close', liveController.onEvtCLEListener);
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var success = function () {
                                        resolve(true);
                                        liveController.connecting = false;
                                        _this.off('ws.error', fail);
                                    };
                                    var fail = function (error) {
                                        reject(error.error ? error.error : new Error('WebSocket connection failed!'));
                                        liveController.connecting = false;
                                        _this.off('ws.afterConnect', success);
                                    };
                                    _this.once('ws.afterConnect', success);
                                    _this.once('ws.error', fail);
                                })];
                        case 5: return [2 /*return*/, _e.sent()];
                    }
                });
            });
        };
        LiveTpl.prototype.revoke = function () {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    return [2 /*return*/, true];
                });
            });
        };
        return LiveTpl;
    }(Subscribe_1.Subscribe));
    var live = new LiveTpl();
    // 如果是调试环境则将内部状态暴露出来
    if (options.__debug__) {
        Object.assign(live, { __controller__: liveController });
        Object.assign(window, { $live: live });
    }
    return live;
}
exports.createLive = createLive;
//# sourceMappingURL=createLive.js.map